import {
  DEFAULT_CHALLENGE_CARD_SUBTITLE_AFTER,
  DEFAULT_CHALLENGE_CARD_SUBTITLE_BEFORE,
  DEFAULT_CHALLENGE_CARD_TITLE_SUFFIX,
  TARGET_TIER_TOKEN,
} from './constants';
import type { ChallengeCardBackground } from './types';

export const STATUS_MATCH_EVIDENCE_BASE = {
  type: 'programTierPhotos',
  fieldNames: { program: 'program', tier: 'tier', photo: 'photos' },
} as const;

export function serializeChallengeCardBackground(background: ChallengeCardBackground): Record<string, unknown> {
  if (background.type === 'image') {
    return { type: 'image', imageId: background.imageId?.trim() ?? '' };
  }
  if (background.type === 'tierGradient') {
    return { type: 'tierGradient' };
  }
  return { type: 'color', value: background.value ?? '#ffffff' };
}

export function parseChallengeCardBackground(value: unknown): ChallengeCardBackground {
  if (!value || typeof value !== 'object') {
    return { type: 'color', value: '#ffffff' };
  }
  const row = value as Record<string, unknown>;
  const type = typeof row.type === 'string' ? row.type : 'color';
  if (type === 'tierGradient') {
    return { type: 'tierGradient' };
  }
  if (type === 'image') {
    return { type: 'image', imageId: typeof row.imageId === 'string' ? row.imageId : '' };
  }
  return { type: 'color', value: typeof row.value === 'string' ? row.value : '#ffffff' };
}

export function buildChallengeCardTitle(suffix: string): string {
  return `${TARGET_TIER_TOKEN}${suffix}`;
}

export function buildChallengeCardSubtitle(before: string, after: string): string {
  return `${before}${TARGET_TIER_TOKEN}${after}`;
}

export function parseChallengeCardTitle(full: string): string {
  if (full.startsWith(TARGET_TIER_TOKEN)) {
    return full.slice(TARGET_TIER_TOKEN.length);
  }
  return DEFAULT_CHALLENGE_CARD_TITLE_SUFFIX;
}

export function parseChallengeCardSubtitle(full: string): { before: string; after: string } {
  const index = full.indexOf(TARGET_TIER_TOKEN);
  if (index === -1) {
    return {
      before: DEFAULT_CHALLENGE_CARD_SUBTITLE_BEFORE,
      after: DEFAULT_CHALLENGE_CARD_SUBTITLE_AFTER,
    };
  }
  return {
    before: full.slice(0, index),
    after: full.slice(index + TARGET_TIER_TOKEN.length),
  };
}
